import { useEffect, useState, useRef, CSSProperties } from 'react'
import cx from 'classnames'
import { useWindowSize } from '@/hooks/useWindowSize'
import { Input, Text } from '@/components/ui'
import s from './style.module.scss'

interface IScaleProps {
  name?: string
  value: number
  onChange: (value: number) => void
  count: number
  prefix?: string
  suffix?: string
  style?: CSSProperties
  showSliderValue?: boolean
  disabled?: boolean
}

const Scale = ({
  name,
  value,
  onChange,
  count,
  prefix,
  suffix,
  style,
  showSliderValue = true,
  disabled
}: IScaleProps) => {
  const [stepWidth, setStepWidth] = useState<number>(0)
  const { width } = useWindowSize()
  const rangeRef = useRef<HTMLInputElement>(null)
  const sliderRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (rangeRef.current && sliderRef.current && count) {
      if (showSliderValue) setStepWidth((rangeRef.current.offsetWidth - sliderRef.current.offsetWidth / 2) / count)
      else setStepWidth((rangeRef.current.offsetWidth - sliderRef.current.offsetWidth / 2 - 83) / count)
    }
  }, [count, showSliderValue, width])

  return (
    <div className={s.scale}>
      <div className={s['scale__range-description']}>
        {prefix && (
          <Text size='md' weight='semibold'>
            {prefix}
          </Text>
        )}
        {suffix && (
          <Text size='md' weight='semibold'>
            {suffix}
          </Text>
        )}
      </div>
      <div className={s['range-wrapper']}>
        <Input
          ref={rangeRef}
          type='range'
          name={name ?? ''}
          className={s.range}
          value={value}
          onChange={(e) => onChange(+e.target.value)}
          step={1}
          min={0}
          max={count}
          style={style}
          fluid
          disabled={disabled}
        />
        <div
          ref={sliderRef}
          className={cx(s.slider, { [s.active]: value >= 0 }, { [s.offset]: !showSliderValue })}
          style={{ transform: `translateX(${value * stepWidth}px)` }}
        >
          <div className={s.slider__content}>
            {showSliderValue && (
              <>
                <Text size='md' weight='bold'>
                  {value}
                </Text>
                <div className={s.tooltip}>{value}</div>
              </>
            )}
          </div>
        </div>
        {!showSliderValue && (
          <>
            <div className={cx(s.slider, s['opposite-values'], s.left)}>
              <Text size='md' weight='bold' className={s.slider__content}>
                {count - value}
              </Text>
            </div>
            <div className={cx(s.slider, s['opposite-values'], s.right)}>
              <Text size='md' weight='bold' className={s.slider__content}>
                {value}
              </Text>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default Scale
